import { render, staticRenderFns } from "./articleDialog.vue?vue&type=template&id=e94a2868&"
import script from "./articleDialog.vue?vue&type=script&lang=js&"
export * from "./articleDialog.vue?vue&type=script&lang=js&"
import style0 from "./articleDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports